import React, { useEffect } from "react";
import img1 from "../../../assets/gps/productImage.png";
import img2 from "../../../assets/gps/productImage2.png";
import img3 from "../../../assets/gps/productImage3.png";
import img4 from "../../../assets/gps/productImage4.png";
import AOS from "aos";
import "aos/dist/aos.css";
const Products = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      offset: 100,
      delay: 200,
    });
  }, []);
  const products = [
    {
      img: img1,
      content: "GPS T4 with 5 year Warranty (with Sim+Software+Relay)",
      price1: "₹ 2240.00",
      price2: "₹ 4200.00",
      aos: "flip-right",
    },
    {
      img: img2,
      content: "GPS T4 with 5 year Warranty (with Sim+Software+Relay)",
      price1: "₹ 2240.00",
      price2: "₹ 4200.00",
      aos: "zoom-in",
    },
    {
      img: img3,
      content: "GPS T4 with 5 year Warranty (with Sim+Software+Relay)",
      price1: "₹ 2240.00",
      price2: "₹ 4200.00",
      aos: "zoom-in",
    },
    {
      img: img4,
      content: "GPS T4 with 5 year Warranty (with Sim+Software+Relay)",
      price1: "₹ 2240.00",
      price2: "₹ 4200.00",
      aos: "flip-left",
    },
    {
      img: img1,
      content: "GPS T4 with 5 year Warranty (with Sim+Software+Relay)",
      price1: "₹ 2240.00",
      price2: "₹ 4200.00",
      aos: "flip-right",
    },
    {
      img: img2,
      content: "GPS T4 with 5 year Warranty (with Sim+Software+Relay)",
      price1: "₹ 2240.00",
      price2: "₹ 4200.00",
      aos: "zoom-in",
    },
    {
      img: img3,
      content: "GPS T4 with 5 year Warranty (with Sim+Software+Relay)",
      price1: "₹ 2240.00",
      price2: "₹ 4200.00",
      aos: "zoom-in",
    },
    {
      img: img4,
      content: "GPS T4 with 5 year Warranty (with Sim+Software+Relay)",
      price1: "₹ 2240.00",
      price2: "₹ 4200.00",
      aos: "flip-left",
    },
  ];
  return (
    <div className="mx-8 lg:mx-12">
      <div className="flex justify-center items-center text-center flex-col sm:py-10 py-5">
        <h1
          className="xl:text-5xl lg:text-3xl text-2xl  font-bold tracking-wide text-black sm:pb-5 pb-3"
          data-aos="fade-right"
        >
          Explore Our Products
        </h1>
        <p
          className="sm:text-lg text-md font-normal xl:w-[62%] sm:w-[80%] mx-auto text-[#868686] tracking-wide"
          data-aos="fade-left"
        >
          Explore our range of high-quality, reliable products designed to meet
          your needs. Each item is crafted with precision, using top-grade
          materials and the latest technology to ensure exceptional performance
          and durability.
        </p>
      </div>
      <div className="grid lg:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-5 mx-auto">
        {products.map((product, index) => {
          return (
            <div className="flex flex-col" key={index} data-aos={product.aos}>
              <img src={product.img} alt="product image" />
              <p className="text-center text-lg py-2 font-semibold">
                {product.content}
              </p>
              <span className="flex justify-center items-center py-2 text-[#F26422] font-bold xl:text-2xl text-xl gap-2">
                <h1>{product.price1}</h1> -<h1>{product.price2}</h1>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Products;
